import AuthService from '../../service';
const partner = {
  getPartner(page,search,sort_order){
      return AuthService.get(`/about/partner?page=${page}&search=${search}&sort_order=${sort_order}`);
  },
  showPartner(id){
     return AuthService.get(`/about/partner/${id}`);
  },
  createPartner(data){
    return AuthService.post(`/about/partner`,data);
  },
  updatePartner(id,data){
    return AuthService.put(`/about/partner/${id}`,data);
  },
  deletePartner(id){
    return AuthService.delete(`/about/partner/${id}`);
  },
}
export default partner
